import React, { useEffect } from 'react';

import Button from 'components/Button';
import Buttons from 'components/Buttons';
import CoachingConstants from 'coaching/CoachingConstants';
import EventTracking from 'lib/EventTracking';
import Heading from 'components/Heading';
import Row from 'components/Row';
import Select from 'components/Select';
import { TimeslotFrequencyInput } from 'globalTypes';

type Props = {
  onSelectWeekly: () => void;
  onSelectEveryOtherWeek: () => void;
  onSelectOnce: () => void;
  interfaceType: 'buttons' | 'select';
  selectedFrequency?: TimeslotFrequencyInput;
  eventPrefix?: string;
};

export default function CoachingSessionFrequencySelection({
  onSelectWeekly,
  onSelectEveryOtherWeek,
  onSelectOnce,
  interfaceType,
  selectedFrequency,
  eventPrefix,
}: Props) {
  function trackKey(key: string) {
    eventPrefix && EventTracking.trackKey(`${eventPrefix}.${key}`);
  }

  useEffect(() => {
    trackKey('view');
  }, []);

  const handlerMap = {
    [TimeslotFrequencyInput.weekly]: () => {
      trackKey('weekly.click');
      onSelectWeekly();
    },
    [TimeslotFrequencyInput.everyOtherWeek]: () => {
      trackKey('every_other_week.click');
      onSelectEveryOtherWeek();
    },
    [TimeslotFrequencyInput.once]: () => {
      trackKey('once.click');
      onSelectOnce();
    },
  };

  if (interfaceType === 'buttons') {
    return (
      <>
        <Row size="small">
          <Heading level="5" flush>
            How often would you like to meet with your coach?
          </Heading>
        </Row>
        <Buttons axis="y" full>
          {CoachingConstants.COACHING_FREQUENCIES.map(freq => (
            <Button
              data-test={`coaching-session-freq-button-${freq.value}`}
              key={freq.value}
              onClick={handlerMap[freq.value]}>
              {freq.label}
            </Button>
          ))}
        </Buttons>
      </>
    );
  }

  return (
    <>
      <Row size="xsmall">
        <Heading level="5" flush>
          Session frequency
        </Heading>
      </Row>
      <Select
        options={CoachingConstants.COACHING_FREQUENCIES}
        onChange={(freq: TimeslotFrequencyInput) => handlerMap[freq]()}
        value={selectedFrequency}
      />
    </>
  );
}
